/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PlanInputs */

const en_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const es_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const fr_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfait`)
};

const de_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const ja_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラン`)
};

const zh_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套餐`)
};

const ar_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الباقة`)
};

const id_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket`)
};

const it_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano`)
};

const ru_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тариф`)
};

const pt_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano`)
};

const ko_plan = /** @type {(inputs: PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요금제`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {PlanInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan = /** @type {((inputs?: PlanInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PlanInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan(inputs)
	if (locale === "es") return es_plan(inputs)
	if (locale === "fr") return fr_plan(inputs)
	if (locale === "de") return de_plan(inputs)
	if (locale === "ja") return ja_plan(inputs)
	if (locale === "zh") return zh_plan(inputs)
	if (locale === "ar") return ar_plan(inputs)
	if (locale === "id") return id_plan(inputs)
	if (locale === "it") return it_plan(inputs)
	if (locale === "ru") return ru_plan(inputs)
	if (locale === "pt") return pt_plan(inputs)
	return ko_plan(inputs)
});